var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.665H13.5C14.4452 12.665 15.4067 13.1647 16.1504 14.1562C16.7828 14.9995 17.1928 16.1201 17.3037 17.335H0.696289C0.807207 16.1201 1.21724 14.9995 1.84961 14.1562C2.59328 13.1647 3.55476 12.665 4.5 12.665Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.665039C10.8419 0.665039 12.335 2.15813 12.335 4C12.335 5.84187 10.8419 7.33496 9 7.33496C7.15813 7.33496 5.66504 5.84187 5.66504 4C5.66504 2.15813 7.15813 0.665039 9 0.665039Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/person_filled.29147fc3594d0e4bcdbc1ab1d7f691d3.svg";
export { ForwardRef as ReactComponent };